import axios from "axios";
import config from '../constants/config';
import { handleApiError } from "../utils/apiErrorHandler";

const API_URL = config.apiBaseUrl; // your backend URL
const googleapiKey = config.GOOGLE_API_KEY;

const JWT_SECRET_KEY = config.JWT_SECRET_KEY;

const CommonService = {
  // Get countries
  getCountry: async () => {
    try {
      const response = await axios.get(`${API_URL}/common/get_country`);
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getCompany: async () => {
    try {
      const response = await axios.get(`${API_URL}/common/get_company`);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getLiveSubs: async (params) => {
    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.get(`${API_URL}/common/get_active_subs`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getActivePaymentMode: async (params) => {
    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.get(`${API_URL}/common/get_active_payment_mode`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getGeofence: async (param) => {
    try {
      const response = await axios.post(`${API_URL}/common/get_geo_fence`, param);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getCountryByCountryId: async (param) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/common/get_city_by_country`, param, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },
  //user current location
  saveLatLng: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/common/save_lat_lng`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  //getAddressFromLat&long
  getAddressFromLatLng: async (lat, lng) => {
    try {
      const response = await axios.post(`${API_URL}/common/google-map-api`, {
        lat,
        lng
      }
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getDirections: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/common/get_direction`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getChating: async (DriveNo, uId) => {
    let params = {};
    params.DriveNo = DriveNo;
    params.uId = uId;

    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/common/get_chats`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }

  },

  getPassengerReply: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/common/get_user_reply`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  saveStartLatLng: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/common/save_start_lat_lng`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  saveWaypoints: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/common/save_waypoints`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  locationVerify: async (params) => {

    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/common/location_verify`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  updatePassword: async (params) => {

    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/common/update_password`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });

      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  createOrder: async (params) => {

    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/common/create-order`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });

      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  verifyPayment: async (params) => {

    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/common/verify-payment`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });

      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getUserTransaction: async (params) => {

    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/common/get_user_transaction`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });

      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getSubscriptionByUID: async (params) => {
    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/common/get_subs_by_uId`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  checkKYC: async (params) => {
    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/common/check_kyc`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  sendAlarm: async (params) => {
    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/common/send_alram`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  saveDriverRating: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {

      const response = await axios.post(`${API_URL}/common/save_rating`,
        params,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${JWT_SECRET_KEY} ${authToken}`
          },
        });

      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

}



export default CommonService;